import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { ProductRepository } from '../repositories/ProductRepository';

interface IInventoryStatus {
    inventory_status: number | string;
    isUpdatedInventorySource?: boolean;
    highVelocityQuantity?: number;
}

export interface IInventoryStatuses {
    [key: string]: IInventoryStatus;
}

export class UpdateProductInventoryUseCase {
    private productRepository: ProductRepository;
    private inventory: IInventoryStatuses = {};

    constructor(inventory: IInventoryStatuses) {
        this.productRepository = diContainer.get(serviceNames.productRepository);
        this.inventory = inventory;
    }

    public execute = () => {
        this.productRepository.updateInventoryStatus(this.inventory);
    };
}
